  <template>
    <main id="mycustomerbolig">
      <div class="clearfix gibson mb2">
        <div class="col-12 px0">
          <div class="clearfix py3">
            <div class="clearfix">
              <div class="col-12 p0 m0">
                <div class="clearfix">
                  <div class="col-12 px0">
                    <p class="h4 semi-bold line-height-2 my2">Dine kunder Minbolig</p>
                    <p class="h5 regular darkblue gibson line-height-golden mb3 col-12 px0">
                      Dit samlede overblik over alle dine kunder - både fra Markedspladsen, din profil-side og Mester til Mester.<br><br>
                      Se historik, information og send tilbud til kunden med det samme herfra - hurtigt og enkelt.
                    </p>
                  </div>
                </div>
                <!-- largedesktop search input -->
                <div class="clearfix">
                  <div class="col-12 px0">
                    <div class="flex justify-start items-center py1 border muted-border mediumgrey shadow mb2">
                      <div class="flex-none px2">
                        <svg class="relative" style="top:3px;" width="18" height="24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path class="st0" d="M8.8 15.4c3.6 0 6.6-3 6.6-6.6s-3-6.6-6.6-6.6 -6.6 3-6.6 6.6S5.2 15.4 8.8 15.4zM15.7 14.2l4 4c0.4 0.4 0.4 1.1 0 1.5s-1.1 0.4-1.5 0l0 0 -4-4c-3.8 3-9.3 2.3-12.3-1.5S-0.5 4.8 3.4 1.9s9.3-2.3 12.3 1.5C18.2 6.6 18.2 11 15.7 14.2L15.7 14.2z"/></svg>
                      </div>
                      <input class="searchBox gibson h4 darkblue regular mb0 p2 pl0" type="search" name="search" v-model="search" placeholder="Søg efter" style="background:transparent;">
                      <!-- <input type="submit" value="Search" class="searchButton"> -->
                    </div>
                  </div>
                  <!-- large desktop filter -->
                  <div class="col-12 px0 flex justify-start items-center mt3 mb2">
                    <div class="col-6 pr1 pl0">
                      <button v-b-toggle.webCustomers class="col-12 p2 px2 gibson dark-button not-rounded flex justify-center items-center">
                        <span class="h5 mb0">Sortér</span>
                        <span class="relative ml2" style="top:4px;">
                          <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                        </span>
                      </button>
                    </div>
                    <div class="col-6 px0">
                      <button v-b-toggle.m2m class="col-12 p2 px2 gibson dark-button not-rounded flex justify-center items-center">
                        <span class="h5 mb0 mr2">Filter</span>
                        <span class="when-closed">
                          <span class="relative" style="top:3px;">
                            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -8 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-down"><path d='M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z' /></svg>
                          </span>
                        </span>
                        <span class="flex-none when-opened">
                          <span class="relative" style="top:3px;">
                            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-5 -7.5 24 24" width="16" height="16" preserveAspectRatio="xMinYMin" class="jam jam-chevron-up"><path d='M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z' /></svg>
                          </span>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <b-collapse id="m2m" class="col-6 right">
                <div class=" my3">
                  <div class="col-9 px0 flex justify-between items-center">
                    <p class="h5 darkblue gibson line-height-3">
                      Vælg
                    </p>
                    <button v-b-toggle.m2m class="white-button border-none not-rounded gibson">
                      <span>
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-6 -6 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-close"><path d='M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z' /></svg>
                      </span>
                    </button>
                  </div>
                  <div class="py1"></div>
                  <!-- <b-form-checkbox id="sortByDate" v-model="status" name="sortByDate" value="accepted" unchecked-value="not_accepted">
                    <span class="ml1 h6 regular relative" style="top:-3px;">Mester-til-Mester</span>
                  </b-form-checkbox> -->
                <div class="col-12 px0 flex justify-start items-center my2">
                  <div class="col-6 px0">
                      <b-form-checkbox id="sortByStatusxxl1" v-model="status" name="sortByStatusxxl1" value="10" >
                        <span class="ml1 h6 regular relative" style="top:-3px;">Mester til Mester</span>
                      </b-form-checkbox>
                      <div class="clearfix"></div>
                      <b-form-checkbox id="sortByHaveWorkxxl1" v-model="status" name="sortByHaveWorkxxl1" value="9" >
                        <span class="ml1 h6 regular relative" style="top:-3px;">private</span>
                      </b-form-checkbox>
                      <div class="clearfix"></div>
                      <b-form-checkbox id="sortByNeedeWorkxxl1" v-model="status" name="sortByNeedeWorkxxl1" value="8" >
                        <span class="ml1 h6 regular relative" style="top:-3px;">Med Tilbud</span>
                      </b-form-checkbox>
                      <div class="clearfix"></div>
                      <b-form-checkbox id="sortByNeedeWorkxxl2" v-model="status" name="sortByNeedeWorkxxl2" value="7" >
                        <span class="ml1 h6 regular relative" style="top:-3px;">Uden Tilbud</span>
                      </b-form-checkbox>
                      <b-form-checkbox id="sortByquickofferl2" v-model="status" name="sortByquickofferl2" value="100" >
                        <span class="ml1 h6 regular relative" style="top:-3px;">Kan ikke afgive tilbud</span>
                      </b-form-checkbox>
                      <b-form-checkbox id="ikkerelevant" v-model="status" name="ikkerelevant" value="12" >
                      <span class="ml1 h6 regular relative" style="top:-3px;">ikke relevant</span>
                      </b-form-checkbox>
                  </div>
                  <div class="col-6 px0">
                    <div class="clearfix"></div>
                    <b-form-checkbox id="sortByStatusxxl2" v-model="status" name="sortByStatusxxl2" value="0" >
                      <span class="ml1 h6 regular relative" style="top:-3px;">Ny opgave</span>
                    </b-form-checkbox>
                    <div class="clearfix"></div>
                    <b-form-checkbox id="sortByHaveWorkxxl2" v-model="status" name="sortByHaveWorkxxl2" value="1" >
                      <span class="ml1 h6 regular relative" style="top:-3px;">I dialog</span>
                    </b-form-checkbox>
                    <div class="clearfix"></div>
                    <b-form-checkbox id="sortByNeedeWorkxxl3" v-model="status" name="sortByNeedeWorkxxl3" value="2" >
                      <span class="ml1 h6 regular relative" style="top:-3px;">Tilbud er sendt</span>
                    </b-form-checkbox>
                    <div class="clearfix"></div>
                    <b-form-checkbox id="sortByNeedeWorkxxl4" v-model="status" name="sortByNeedeWorkxxl4" value="3" >
                      <span class="ml1 h6 regular relative" style="top:-3px;">Vandt opgaven</span>
                    </b-form-checkbox>
                    <div class="clearfix"></div>
                    <b-form-checkbox id="sortByNeedeWorkxxl5" v-model="status" name="sortByNeedeWorkxxl5" value="4" >
                      <span class="ml1 h6 regular relative" style="top:-3px;">Opgaven er udført</span>
                    </b-form-checkbox>
                    <div class="clearfix"></div>
                    <b-form-checkbox id="sortByNeedeWorkxxl6" v-model="status" name="sortByNeedeWorkxxl6" value="5" >
                      <span class="ml0 h6 regular relative" style="top:-3px;">Vandt ikke opgaven</span>
                    </b-form-checkbox>
                  </div>
                </div>
                  <div class="py1"></div>
                  <div class="clearfix">
                    <button class="col-6 action-button p2 gibson not-rounded flex justify-center items-center line-height-1" @click="toggleFilter(status)">
                      <span class="h4 mb0">Sorter nu</span>
                      <span class="ml1"><i class="el-icon-right"></i></span>
                    </button>
                  </div>
                </div>
              </b-collapse>
              <b-collapse id="webCustomers" class="col-6">
                <div class="clearfix my3">
                  <div class="col-9 px0 flex justify-between items-center">
                    <p class="h5 darkblue gibson line-height-3">
                      Tilpas rækkefølgen
                    </p>
                    <button v-b-toggle.webCustomers class="white-button border-none not-rounded gibson">
                      <span>
                        <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-6 -6 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-close"><path d='M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z' /></svg>
                      </span>
                    </button>
                  </div>
                  <div class="pb3"></div>
                    <b-form-group :value.sync="statusDate" v-slot="{ ariaDescribedby }">
                      <b-form-radio-group >
                  <b-form-radio id="sortByDatexxl" v-model="statusDate" :aria-describedby="ariaDescribedby" name="sortByDatexxl" value="1" >
                    <span class="ml1 h6 regular relative" style="top:-3px;">Sorter efter mødedato</span>
                  </b-form-radio>
                  <div class="clearfix"></div>
                  <b-form-radio id="sortByStatusxxl" v-model="statusDate" :aria-describedby="ariaDescribedby" name="sortByStatusxxl" value="2" >
                    <span class="ml1 h6 regular relative" style="top:-3px;">Sorter efter status</span>
                  </b-form-radio>
                  <div class="clearfix"></div>
                  <b-form-radio id="offerSentxxl" v-model="statusDate" :aria-describedby="ariaDescribedby" name="offerSentxxl" value="3" >
                    <span class="ml1 h6 regular relative" style="top:-3px;">Sorter efter sendt tilbud dato</span>
                  </b-form-radio>
                  <div class="clearfix"></div>
                  <b-form-radio id="followUpxxl" v-model="statusDate" :aria-describedby="ariaDescribedby" name="followUpxxl" value="4" >
                    <span class="ml1 h6 regular relative" style="top:-3px;">Sorter efter opfølgningsdato</span>
                  </b-form-radio>
                    </b-form-radio-group>
                        </b-form-group>
                  <div class="pb5"></div>
                  <div class="clearfix">
                    <button class="col-6 action-button p2 gibson not-rounded" @click="toggleSort(statusDate)" >
                      <span class="h4 mb0">Sorter nu</span>
                      <span class="ml1"><i class="el-icon-right"></i></span>
                    </button>
                  </div>
                </div>
              </b-collapse>
              <div class="flex flex-column col-12 p0 m0 my2" v-if="browserName !== 'safari'">
                <p class="col-12 h5 semi-bold darkblue p0">Oversigt over dine kunder om året</p>
                <div class="flex flex-wrap">
                <button @click="filteryear(item)" :id="'yearfilter-' + item" class="primary-button-green pointer regular h5 white p2 mr1" style="width:120px" v-for="(item,index) in allyear" :key="index">{{item}}
                </button>
                <!-- <a href="#/anbefalinger-sammendrag" class="no-underlined pointer">View ALL list</a> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <!-- loader -->
    <div class="col-12" v-if="loading">
      <div class="loader"></div>
    </div>
    <div class=" flex flex-wrap justify-start items-stretch" v-else>
      <div class="flex items-stretch relative lg-col-3 md-col-4" v-for="item in SearchItem" :key="item.id">
        <div class="col-12 border muted-border p2 py3 shadow mb3">
          <!-- Status icon -->
          <div class="col-12 text-right">
            <div>
              <el-tooltip placement="bottom" effect="light">
                <img src="static/svg/check-mark.svg" rel="preload" width="12%">
              </el-tooltip>
            </div>
          </div>
          <!-- date and time -->
          <div class="clearfix mb2 mt2" >
            <div class="col-12 gibson darkblue flex">
              <div class="pr2">
                <svg fill="currentColor" width="48" height="48" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" ><path d="m116 166c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm0 0"/><path d="m30 512h452c16.5 0 30-13.5 30-30v-412c0-16.5-13.5-30-30-30h-16v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-16c-16.5 0-30 13.5-30 30v412c0 16.5 13.5 30 30 30zm452-20h-452c-5.5 0-10-4.5-10-10v-336h472v336c0 5.5-4.5 10-10 10zm-56-462c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-36 30h16v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h56c5.5 0 10 4.5 10 10v56h-472v-56c0-5.5 4.5-10 10-10zm0 0"/><path d="m396 166h-240c-5.5 0-10 4.5-10 10s4.5 10 10 10h240c5.5 0 10-4.5 10-10s-4.5-10-10-10zm0 0"/><path d="m256 226c-60.7 0-110 49.3-110 110s49.3 110 110 110 110-49.3 110-110-49.3-110-110-110zm0 200c-49.6 0-90-40.4-90-90s40.4-90 90-90 90 40.4 90 90-40.4 90-90 90zm0 0"/><path d="m288.9 308.9-42.9 42.9-22.9-22.9c-3.9-3.9-10.2-3.9-14.1 0s-3.9 10.2 0 14.1l30 30c2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l50-50c3.9-3.9 3.9-10.2 0-14.1s-10.2-3.9-14.1 0zm0 0"/></svg>
              </div>
              <div class="">
                <!-- <p class="h4 semi-bold line-height-1 mb0" style="margin-bottom:5px;">
                  {{moment('August 29, 2022').locale('da').format('LL')}}
                </p> -->
                <p class="regular line-height-1 mb0" style="font-size:18.5px;">
                  kl. 1000
                </p>
              </div>
            </div>
          </div>
          <!-- customer name -->
          <div class="col-12 gibson">
            <div class="clearfix">
              <div class="darkblue mb1">
                <div class="flex justify-start items-center" style="visibility: hidden;">
                  <div>
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" style="top:3px;" class="relative jam jam-user-circle"><path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-14a4 4 0 0 1 4 4v2a4 4 0 1 1-8 0V8a4 4 0 0 1 4-4zm0 2a2 2 0 0 0-2 2v2a2 2 0 1 0 4 0V8a2 2 0 0 0-2-2zM5.91 16.876a8.033 8.033 0 0 1-1.58-1.232 5.57 5.57 0 0 1 2.204-1.574 1 1 0 1 1 .733 1.86c-.532.21-.993.538-1.358.946zm8.144.022a3.652 3.652 0 0 0-1.41-.964 1 1 0 1 1 .712-1.868 5.65 5.65 0 0 1 2.284 1.607 8.032 8.032 0 0 1-1.586 1.225z'/></svg>
                  </div>
                  <p class="h6 line-height-1 m0 ml1 p0"></p>
                </div>
              </div>
            </div>
          </div>
          <div class="darkblue mb1 flex col-12 p0 pointer"  @click="getReviewIdbycustomerId(item.CUSTOMER_ID)" > 
            <div class="flex justify-start items-center mr-auto" >
              <div>
                <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" style="top:3px;" class="relative jam jam-user-circle"><path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-14a4 4 0 0 1 4 4v2a4 4 0 1 1-8 0V8a4 4 0 0 1 4-4zm0 2a2 2 0 0 0-2 2v2a2 2 0 1 0 4 0V8a2 2 0 0 0-2-2zM5.91 16.876a8.033 8.033 0 0 1-1.58-1.232 5.57 5.57 0 0 1 2.204-1.574 1 1 0 1 1 .733 1.86c-.532.21-.993.538-1.358.946zm8.144.022a3.652 3.652 0 0 0-1.41-.964 1 1 0 1 1 .712-1.868 5.65 5.65 0 0 1 2.284 1.607 8.032 8.032 0 0 1-1.586 1.225z'/></svg>
              </div>
              <p class="h6 line-height-1 m0 ml1 p0">Egne kunder</p>
            </div>
            <div class="ml-auto flex items-center">
              <image-rating :rating="5" src='/static/svg/single-house-blue.svg' :max-rating="5" :increment="0.5" :item-size="15" :spacing="1" :show-rating="false" :read-only="true"></image-rating>
            </div>
          </div>
          <div class="col-12 flex justify-between items-start">
            <p class="h4 darkblue semi-bold line-height-3">
              {{item.CUSTOMER_NAME}}
            </p>
          </div>
          <!-- customer address -->
          <template>
            <div class="col-12 gibson">
              <span>Minbolig Customer ID: {{item.CUSTOMER_ID}}</span>
            </div>
          </template>
          <!-- large desktop se mere collapse button -->
          <div class="col-12 gibson mt3">
            <p v-b-toggle="'optionsCollapse'" class="h5 primarycolor regular line-height-1 mb0 flex justify-between items-start">
              <span>Se mere information om kunden</span>
              <span class="when-closed">
                <span class="relative" style="top:3px;">
                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-circle-down"><path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-6.172l3.536-3.535a1 1 0 0 1 1.414 1.414l-4.243 4.243a1 1 0 0 1-1.414 0L5.05 9.707a1 1 0 0 1 1.414-1.414L10 11.828z' /></svg>
                </span>
              </span>
              <span class="flex-none when-opened">
                <span class="relative" style="top:3px;">
                  <svg fill="currentColor" width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" preserveAspectRatio="xMinYMin" class="jam jam-chevron-circle-up-f"><path d='M10 9.172l3.536 3.535a1 1 0 0 0 1.414-1.414L10.707 7.05a1 1 0 0 0-1.414 0L5.05 11.293a1 1 0 0 0 1.414 1.414L10 9.172zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z' /></svg>
                </span>
              </span>
            </p>
            <div class="py1"></div>
          </div>
          <!-- large desktop notes button -->
          <!-- <div class="col-12 mb1">
          <a type="button" :href="'#/anbefaling-boligejere?cid=' + item.ID" class="kundebutton col-12 outlined-action-button p2 flex justify-center items-center gibson line-height-1" >
            <p class="semi-bold line-height-1 flex justify-start items-center mb0">
              <span class="relative mr2" style="top:3px;">
                <svg fill="currentColor" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M492.6 400.6L392.2 300.2c-12-12-31.5-12-43.4 0l-26.1 26.1c-8.2 8.2-10.8 19.8-7.8 30.2l-9.8 9.8c0 0 0 0 0 0 -7 7-50.5-3.7-103.1-56.4 -52.6-52.6-63.4-96.1-56.4-103.1 0 0 0 0 0 0l9.9-9.9c2.8 0.8 5.7 1.2 8.5 1.2 7.9 0 15.7-3 21.7-9l26.1-26.1c12-12 12-31.5 0-43.4L111.4 19.4c-5.8-5.8-13.5-9-21.7-9 -8.2 0-15.9 3.2-21.7 9l-26.1 26.1c-8.2 8.2-10.8 19.8-7.8 30.2 0 0-8.3 8.4-8.8 9 -27.8 30.8-33 79.4-14.6 137.5 18 56.9 56.9 117.1 109.4 169.6 52.5 52.5 112.7 91.3 169.6 109.4C312.6 508.4 334 512 353.4 512c31.8 0 58.3-9.6 77.4-28.7l5.5-5.5c2.7 0.8 5.6 1.2 8.5 1.2 8.2 0 15.9-3.2 21.7-9l26.1-26.1C504.5 432 504.5 412.5 492.6 400.6zM89.7 41.2l100.3 100.3 -26.1 26.1c0 0 0 0 0 0l-0.4-0.4 -49.8-49.8L63.6 67.2 89.7 41.2zM409 461.6c0 0 0 0 0 0 -22.1 22.1-61.1 25.7-110 10.3 -52.3-16.6-108.1-52.7-157.2-101.8C92.8 321 56.7 265.2 40.1 212.9c-15.5-48.8-11.8-87.9 10.3-110l0 0 2.8-2.8 77.9 77.9 -7.1 7.1c0 0 0 0 0 0 -29.6 29.6 6 96.1 56.4 146.6 37.7 37.7 84.5 67.1 118.1 67.1 11.3 0 21.1-3.3 28.5-10.8 0 0 0 0 0 0l7.1-7.1 77.9 77.9L409 461.6zM444.8 448.4L344.4 348l26.1-26.1L470.8 422.3C470.8 422.3 444.8 448.4 444.8 448.4z"/><path d="M388.8 123.2c-29.2-29.2-68-45.3-109.3-45.3 -8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 33.1 0 64.2 12.9 87.6 36.3 23.4 23.4 36.3 54.5 36.3 87.6 0 8.5 6.9 15.4 15.4 15.4 8.5 0 15.4-6.9 15.4-15.4C434.1 191.2 418 152.4 388.8 123.2z"/><path d="M443.9 68.1C400 24.2 341.6 0 279.5 0c-8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 53.9 0 104.6 21 142.7 59.1 38.1 38.1 59.1 88.8 59.1 142.7 0 8.5 6.9 15.4 15.4 15.4 8.5 0 15.4-6.9 15.4-15.4C512 170.4 487.8 112 443.9 68.1z"/><path d="M333.7 178.3c-14.7-14.7-33.5-22.5-54.3-22.5 0 0 0 0 0 0 -8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 0 0 0 0 0 0 12.6 0 23.6 4.5 32.5 13.5 8.8 8.8 13.5 20.1 13.5 32.5 0 8.5 6.9 15.4 15.4 15.4h0c8.5 0 15.4-6.9 15.4-15.4C356.2 211.7 348.4 193 333.7 178.3z"/></svg>
              </span>
              <span class="h6 line-height-1 mb0">Make A review</span>
            </p>
          </a>
          </div> -->
          <!-- large desktop notes button -->
          <div class="col-12 mb1">
            <button @click="showMeetingTilbudcreate(item)" class="kundebutton col-12 outlined-action-button p1 flex justify-center items-center gibson line-height-1">
              <span class="relative col-4 flex justify-end pr2 ">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 21.805 13.414">
                  <path id="opret_tilbud" data-name="opret tilbud" d="M.476,13.414A.477.477,0,0,1,0,12.938V3.99a.477.477,0,0,1,.476-.476H1.49L2.337.352A.476.476,0,0,1,2.778,0H2.8a.507.507,0,0,1,.12.015L15.261,3.322a.475.475,0,0,1,.348.395l.317,2.233a2.79,2.79,0,0,1,2.308,1.676,2.819,2.819,0,0,1,.134.385A5.351,5.351,0,0,1,19,7.988h.411a2.374,2.374,0,0,1,1.692.7,2.4,2.4,0,0,1,.7,1.692.476.476,0,1,1-.951,0A1.443,1.443,0,0,0,19.413,8.94c-.15,0-.289,0-.423.007-.113,0-.221.006-.319.006-.078,0-.15,0-.216-.006a2.8,2.8,0,0,1-3.749,2.41l-1.039,1.818a.476.476,0,0,1-.413.24Zm.475-.952H12.978l.9-1.581a2.809,2.809,0,0,1-.875-1.3A1.434,1.434,0,1,1,14,9.2a1.723,1.723,0,0,0,.421.737l.839-1.468-2.285-4H.951Zm14.717-2a1.73,1.73,0,0,0,.414-3.409l.179,1.259a.483.483,0,0,1-.037.388l-.977,1.709A1.722,1.722,0,0,0,15.668,10.462ZM12.55,8.145a.476.476,0,0,0,.328.457,2.8,2.8,0,0,1,.207-.935l-.055,0A.476.476,0,0,0,12.55,8.145Zm2.429-2.1-.268-1.89L13.752,3.9ZM12.3,3.514,3.133,1.058,2.474,3.514Z" fill="#4dcf55"/>
                </svg>
              </span>
              <span class="h6 mb0 line-height-1 semi-bold col-8 p0 flex justify-start">tilbud - PID {{item.PROJECT_ID}}</span>
            </button>
          </div>
          <!-- large desktop skriv til kunden  -->  <!--  v-if="item.PROJECT_CONTRACT_STATUS == 'signed'" -->
          <div class="col-12 mb1" >
            <button @click="showprojectdash()" class="kundebutton col-12 outlined-primary-button p1 flex justify-center items-center gibson line-height-1">
              <span class="relative col-4 flex justify-end pr2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 13.366 13.228">
                  <path id="Styr_Projekt" data-name="Styr Projekt" d="M9.651,13.131a1.646,1.646,0,0,1-.557.1H1.654A1.656,1.656,0,0,1,0,11.574V1.655A1.656,1.656,0,0,1,1.654,0H6.633a.417.417,0,0,1,.289.135l3.706,3.706.019.02a.414.414,0,0,1,.1.273V8.649a4,4,0,0,1,2.574,2.089.414.414,0,0,1,0,.371c-.043.086-1.081,2.119-2.97,2.119A2.584,2.584,0,0,1,9.651,13.131ZM8.23,10.922A2.813,2.813,0,0,0,10.352,12.4a2.8,2.8,0,0,0,2.123-1.476,2.812,2.812,0,0,0-2.123-1.478A2.8,2.8,0,0,0,8.23,10.922ZM.828,1.655v9.92a.827.827,0,0,0,.826.826H8.381a4.868,4.868,0,0,1-1-1.291.418.418,0,0,1,0-.371,3.99,3.99,0,0,1,2.6-2.093l-.063.01V4.548H6.615A.415.415,0,0,1,6.2,4.134V.828H1.654A.828.828,0,0,0,.828,1.655ZM10,8.643h0Zm.454-.022h0Zm-.022,0h0Zm-.023,0h0Zm-.023,0h0Zm-.061,0h0Zm.032,0h0ZM7.029,3.72H9.335L7.029,1.413Zm2.2,7.2a1.123,1.123,0,1,1,1.123,1.123A1.124,1.124,0,0,1,9.23,10.924Zm.828,0a.3.3,0,1,0,.295-.3A.3.3,0,0,0,10.058,10.924ZM2.9,9.8a.414.414,0,1,1,0-.828H5.657a.414.414,0,1,1,0,.828Zm0-2.069a.414.414,0,1,1,0-.828H7.727a.414.414,0,0,1,0,.828Zm0-2.559a.414.414,0,1,1,0-.828h1.24a.414.414,0,1,1,0,.828Z" fill="#19a3c0"/>
                </svg>
              </span>
              <span class="h6 mb0 line-height-1 semi-bold col-8 p0 flex justify-start">Styr projekt - {{item.PROJECT_ID}}</span>
            </button>
          </div>
          <div class="col-12 mb1">
            <div class="col-12 muted-background border-none darkblue semi-bold pl2 not-rounded gibson mb0 flex justify-center items-center" style="height:48px;font-size:18.5px!important;" v-for="(itemitem,index) in item.STATUS" :key="index" v-if="itemitem.IS_SELECTED">
              <template>
                {{itemitem.TITLE_DK}}
              </template>
            </div>
          </div>
          <!-- large desktop status-->
          <div class="clearfix mb1">
            <!-- status select -->
            <input type="hidden" :id="'tilbudstatusval-'" >
            <div  class="col-12">

              <button type="button" :id="'recommendInvitation-'" class="hide" v-confirm="{ ok: confirmRecommendInvitation('4', item, 'yes'), cancel: confirmRecommendInvitation('4', item, 'no'), message: 'Vil du sende en invitation til en anbefaling?', okText: 'Ja', cancelText: 'Nej',}">Recommend Invitation</button>
              <!-- <button type="button" :id="'recommendInvitationnew-' + item.id_appointment" class="hide " v-confirm="{ ok: confirmRecommendInvitationnew('100', item, 'yes'), cancel: confirmRecommendInvitationnew(item.tilbudstatus, item, 'no'), message: 'Du har valgt, at du ikke kan afgive tilbud på opgaven.', okText: 'Ja', cancelText: 'Nej'}">Recommend Invitation</button> -->
              <!-- <button type="button" :id="'didNotWinTask-' + item.id_appointment" class="hide " v-confirm="{ ok: confirmDidNotWinTask('5', item, 'yes'), cancel: confirmDidNotWinTask(item.tilbudstatus, item, 'no'), message: 'Ønsker du at slette kunden?', okText: 'Ja', cancelText: 'Nej'}">Did not win the task</button> -->
            </div>
          </div>
          <!-- large desktop reminders setup -->
          <div class="col-12 flex justify-start items-center mt2">
            <button v-b-toggle="'setReminder'" :id="'setReminderb'" class="p1 flex-auto gibson outlined-standard-button not-rounded border-none justify-start items-center">
              <template>
                <!-- if date is set show -->
                <div class="flex justify-start items-center regular">
                  <span class="relative mr1" style="top:2px;">
                    <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-3 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-bell"><path d='M13.666 11.782L13 11.186V6a4 4 0 1 0-8 0v5.186l-.666.596A6.987 6.987 0 0 0 2.29 15h13.42a6.987 6.987 0 0 0-2.044-3.218zM12 17a3 3 0 0 1-6 0H0a8.978 8.978 0 0 1 3-6.708V6a6 6 0 1 1 12 0v4.292A8.978 8.978 0 0 1 18 17h-6zm-3 1a1 1 0 0 0 1-1H8a1 1 0 0 0 1 1z'/></svg>
                  </span>
                  <span  class="mb0 semi-bold" style="font-size:18.5px;">
                    Tilføj påmindelse
                  </span>
                </div>
              </template>
            </button>
            <button  class="p1 delete-button flex justify-center items-start gibson line-height-1">
              <span><i class="el-icon-delete"></i></span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="Reviews" ref="customerreviewsbypartners" hide-header hide-footer centered>
      <div class="col-12" v-if="reviewsloading">
        <div class="loader"></div>
      </div>
      <div class="center p2" v-else>
        <div class="flex justify-end">
          <button type="reset" @click="closereviewsmodal()" class="h4 bold border-none transparent">
            <i class="el-icon-circle-close"></i>
          </button>
        </div>
        <div v-if="allreviewsbycid.length > 0">
          <div class="flex justify-around mobile-flex-column darkblue">
            <div class="xs-col-12 sm-col-3 lg-col-3 md-col-3 highlights flex flex-column mmb3">
              <div class="my2">
                  <img :src="customerdetails.image" width="80" height="80" class="rounded-circle border">
              </div>
              <div class="center pt2 sm-hide lg-hide md-hide">
                <p class="semi-bold h4">Hej, jeg er {{customerdetails.name}}</p>
                <p class="h6">{{customerdetails.zip}}</p>
              </div>
              <div class=" py3 border border-top-0 border-left-0 border-right-0 mx2">
                  <p class="my2 h6"><span><svg id="ratings_star" data-name="ratings star" xmlns="http://www.w3.org/2000/svg" width="13.599" height="14.137" viewBox="0 0 13.599 14.137"><path id="Rectangle" d="M284.537,378.051l6.8-4.363,6.8,4.363v9.775h-13.6Z" transform="translate(-284.537 -373.688)" fill="#19a3c0"/><path id="Path_4010" data-name="Path 4010" d="M298.363,389.159l.992,2.663h2.55l-2.153,1.615,1.048,2.692-2.436-1.813-2.437,1.813,1.048-2.692-2.153-1.615h2.55Z" transform="translate(-291.563 -384.258)" fill="#fff"/></svg></span> {{allreviewsbycid.length}} reviews</p>
                  <p class="my2 h6" v-if="customerdetails.email_verified"><span><svg xmlns="http://www.w3.org/2000/svg" id="verified" width="11.479" height="14.137" viewBox="0 0 11.479 14.137"><path id="Path_1126" data-name="Path 1126" d="M5.551,14.093A14.449,14.449,0,0,1,2.8,12.2,9.771,9.771,0,0,1,.893,10.01,5.584,5.584,0,0,1,0,7.068V2.416a.422.422,0,0,1,.274-.4L5.591.027a.42.42,0,0,1,.3,0L11.2,2.021a.422.422,0,0,1,.274.4V7.068a5.584,5.584,0,0,1-.893,2.942A9.771,9.771,0,0,1,8.676,12.2a14.436,14.436,0,0,1-2.748,1.888.423.423,0,0,1-.377,0Z" transform="translate(0 0)" fill="#4dcf55"/><path id="Icon_feather-check" data-name="Icon feather-check" d="M6.8,11.872a.421.421,0,0,1-.3-.124L5.124,10.372a.422.422,0,0,1,.6-.6L6.8,10.853,9.528,8.124a.422.422,0,0,1,.6.6L7.1,11.749A.421.421,0,0,1,6.8,11.872Z" transform="translate(-1.885 -3.355)" fill="#fff"/></svg></span> Identified Verified</p>
                  <p class="my2 h6" v-if="customerdetails.payproffv2_account_id"><span><svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14"><g id="payproff" transform="translate(-743 -333)"><rect id="Rectangle_738" data-name="Rectangle 738" width="14" height="14" transform="translate(743 333)" fill="#2265fc"/><path id="Path_4030" data-name="Path 4030" d="M-1813.8,992.119h7.174a2.932,2.932,0,0,1,2.316,2.682c.092,2.235-2.316,2.8-2.316,2.8h-4.188l-1.948,1.85v-4.22h4.36l-1.4,1.391h1.4l2.478-2.42h-7.877v7.78l3.344-3.342h3.831a3.841,3.841,0,0,0,2.527-1.325,3.719,3.719,0,0,0,.9-2.516,3.854,3.854,0,0,0-.9-2.382,4.043,4.043,0,0,0-2.527-1.325h-7.174Z" transform="translate(2558.496 -656.539)" fill="#fff"/></g></svg></span> Payproff Verified</p>
              </div>
              <div class="flex flex-column items-start mt3 px3 xs-col-8 mx-auto md-col-12 lg-col-12 sm-col-12">
                  <p class="semi-bold h5 mb2">{{customerdetails.name}} confirmed</p>
                  <p class="regular font14 mb1" v-if="customerdetails.email_verified"><i class="green el-icon-check"></i> Identified</p>
                  <p class="regular font14 mb1" v-if="customerdetails.email_verified"><i class="green el-icon-check"></i> Email Address</p>
                  <p class="regular font14" v-if="customerdetails.mobile"><i class="green el-icon-check"></i> Phone Number</p>
              </div>
            </div>
            <div class="xs-col-12 sm-col-8 lg-col-8 md-col-8 highlights p0">
              <div class="py2 mx2 border border-top-0 border-left-0 border-right-0 flex flex-column justify-start items-start xs-hide ">
                <p class="semi-bold h4">Hej, jeg er {{customerdetails.name}}</p>
                <p class="h6">{{customerdetails.address}}</p>
              </div>
              <p class="my2 flex col-12 justify-start">{{allreviewsbycid.length}} reviews</p>
              <div class="px0 flex flex-column justify-start col-12">
                <div class="p2 flex flex-column items-start m0 p0" v-for="review in allreviewsbycid" :key="review.id">
                  <p class="font12 graylightcolor m0">{{moment(new Date(review.UF_REVIEW_DATE)).format('D MMMM YYYY')}}</p>
                  <p class="darkble h6 regular">{{review.UF_COMMENT}}</p>
                  <div class="flex items-center justify-start">
                    <span>
                      <img src="https://www.haandvaerker.dk/content/3.0/img/supplier/rating/customer.png" width="40" height="40" class="rounded-circle border">
                    </span>
                    <div class="flex flex-column p0 m0 items-start pl1">
                      <p class="darkble font13 regular m0">{{review.COMPANY_NAME}}</p>
                      <p class="graylightcolor font12 regular m0">{{review.COMPANY_ADDRESS}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="my4" v-else>
          Ingen anmeldelser
        </div>
      </div>
    </b-modal>
    <loading :show="show" :label="label" :overlay="overlay"></loading>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    <noneligibleFeaturepop ref="noneligibleFeaturepop"></noneligibleFeaturepop>
  </main>
</template>
<script>
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
import fileUploadInput from '../../components/file-upload-input'
import VueGallerySlideshow from 'vue-gallery-slideshow'
import { Datetime } from 'vue-datetime'
import Countdown from '../../components/Countdown'
import Countdown2 from '../../components/Countdown2'
import gql from 'graphql-tag'
import {ImageRating} from 'vue-rate-it'
import datePicker from 'vue-bootstrap-datetimepicker'
import noneligibleFeaturepop from './noneligibleFeaturepop'
export default {
  name: 'allmeetings',
  components: {
    loading,
    Countdown,
    Countdown2,
    fileUploadInput,
    VueGallerySlideshow,
    datetime: Datetime,
    Simplert,
    datePicker,
    noneligibleFeaturepop,
    ImageRating
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    var mobile = this.$route.query.mobile
    if (mobile !== undefined) {
      this.search = mobile
      this.$router.push('/alle-moeder')
    }
    this.klimaprofil = localStorage.getItem('ClimatePartner')
    this.salesPersonbitrix = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    this.Reload()
  },
  data () {
    return {
      disableStatusSelection: false,
      items: [],
      kundeitem: [],
      status: [],
      klimaprofil: '',
      SearchItem: [],
      files: [],
      statusDate: '',
      commentId: '',
      browserName: '',
      show: false,
      upload_token: '',
      clear_quotation_attachment: false,
      tilbud_id: '',
      index: null,
      modalShowPris: false,
      urlpris: '',
      datereminder: null,
      label: 'Loading...',
      service_reminder: '',
      AflyseText: '',
      search: '',
      CommentText: '',
      CommentCustomText: '',
      AflyseTexttitle: '',
      Aflysetitle: '',
      Datosetitle: '',
      dateDato: '',
      timeDato: '',
      Aflyseid: '',
      Datoeid: '',
      komments: [],
      CommentCustomerText: '',
      showMobile: false,
      textAflyseReason: '',
      textDatoReason: '',
      isLoadingAflyse: true,
      isLoadingDato: false,
      overlay: true,
      send_email: true,
      meetingShow: false,
      modalShowAflyseText: false,
      modalShowCommentText: false,
      modalShowkomment: false,
      textKomment: '',
      modalShowFeedback: false,
      textFeedback: '',
      modalShowCommentCustomerText: false,
      modalShowAflyse: false,
      modalShowDato: false,
      loading: true,
      salesPersonbitrix: '',
      haaId: '',
      oldestFirst: false,
      ascending: true,
      sampleMeeting: {
        id: '',
        type: '',
        estimate: '',
        city: '',
        postnummer: '',
        price: '',
        date: ''
      },
      config: {
        format: 'LL',
        minDate: new Date(),
        sideBySide: true,
        useCurrent: false,
        debug: true,
        showClear: false,
        showClose: false
      },
      configTime: {
        format: 'HH:mm',
        minDate: new Date(),
        sideBySide: true,
        useCurrent: false,
        // debug: true
        showClear: false,
        showClose: false
      },
      customer: {
        id: 5,
        firstName: '',
        lastName: '',
        email: ''
      },
      apollo: {
        customers: gql`query {
          customers {
            name,
            phoneNumber,
            email
          }
        }`
      },
      partnerImg: '',
      modalPriceFeedback: false,
      modalSurvey: false,
      surveyDescription: '',
      surveySteps: {
        active: 0
      },
      statusItem: [],
      statusValue: '',
      feedbackLoading: true,
      surveyId: '',
      priceFeedBackData: {
        priceManualChecked: false,
        price: 0,
        priceManualDisabled: true,
        steps: 1,
        nps: 0,
        note: ''
      },
      statusConfirmation: false,
      allyear: [],
      activeyear: '',
      optionikke: '',
      alloptionikke: [
        { value: 0, text: 'Vælg venligst en mulighed' },
        { value: 101, text: 'Kunden skal ikke have det lavet' },
        { value: 102, text: 'Jeg har for travlt og kan ikke varetage opgaven alligevel' },
        { value: 103, text: 'Projektet skal først laves langt ude i fremtiden' },
        { value: 104, text: 'Kunden ønsker først et tilbud langt ude i fremtiden' },
        { value: 105, text: 'Kunden har fået opgaven udført af en anden håndværker' }
      ],
      showwikkeerror: false,
      // tilbudstatustext: [
      //   {text: 'Ny opgave', value: '0'},
      //   {text: 'I dialog', value: '1'},
      //   {text: 'Tilbud er sendt', value: '2'},
      //   {text: 'Kan ikke afgive tilbud', value: '100'},
      //   {text: 'Vandt opgaven', value: '3'},
      //   {text: 'Opgaven er udført', value: '4'},
      //   {text: 'Ikke relevant', value: '6'}
      // ],
      allreviewsbycid: [],
      customerdetails: {
        name: '',
        email: '',
        mobile: '',
        image: '',
        address: '',
        email_verified: '',
        payproffv2_account_id: ''
      },
      reviewsloading: false
    }
  },
  filters: {
    truncate: function (text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix
      } else {
        return text
      }
    }
  },
  watch: {
  },
  computed: {
  },
  mounted () {
    this.getyearsarray()
  },
  methods: {
    getbrowser () {
      let userAgent = navigator.userAgent
      if (userAgent.match(/chrome|chromium|crios/i)) {
        this.browserName = 'chrome'
      } else if (userAgent.match(/firefox|fxios/i)) {
        this.browserName = 'firefox'
      } else if (userAgent.match(/safari/i)) {
        this.browserName = 'safari'
        this.status = 9
        console.log('browserName', this.browserName)
      } else if (userAgent.match(/opr\//i)) {
        this.browserName = 'opera'
      } else if (userAgent.match(/edg/i)) {
        this.browserName = 'edge'
      } else {
        this.browserName = 'No browser detection'
      }
    },
    getyearsarray () {
      var initialyear = 2018
      var latestyear = new Date().getFullYear()
      for (var i = initialyear; i <= latestyear; i++) {
        this.allyear.push(initialyear)
        initialyear++
      }
      this.allyear.reverse()
    },
    filteryear (year) {
      if (this.activeyear !== '') {
        var oldyear = this.activeyear
        document.getElementById('yearfilter-' + oldyear).classList.add('primary-button-green')
        document.getElementById('yearfilter-' + oldyear).classList.remove('green-background')
      }
      this.activeyear = year
      document.getElementById('yearfilter-' + year).classList.add('green-background')
      document.getElementById('yearfilter-' + year).classList.remove('primary-button-green')
      var itemsyear = []
      var filteredyear = []
      itemsyear = this.items.filter((item) => {
        var createditemyear = new Date(item.createdtime).getFullYear()
        if (createditemyear === year) {
          return item.createdtime
        }
      })
      itemsyear.forEach(function (value) {
        filteredyear.push(value)
      })
      this.SearchItem = this.filterSearch(filteredyear)
    },
    getdataigibility (appid, contactid) {
      if (this.klimaprofil === 'false') {
        this.$refs.noneligibleFeaturepop.showmodel(this.klimaprofil, '', 'ClimatePartner')
      } else {
        this.gotoKlima(appid, contactid)
      }
    },
    gotoKlima (appointmentId, contactId) {
      this.$router.push('/klima/checklist?appointmentId=' + appointmentId + '&contactId=' + contactId)
    },
    showprojectdash () {
      this.$router.push('/customer-projects/project-dashboard')
    },
    Reload () {
      if (screen.width <= 640) {
        this.showMobile = true
      } else {
        this.showMobile = false
      }
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/jobs', { headers }, data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.items = res.data
            if (this.search !== '') {
              this.updateSearch()
            } else {
              this.SearchItem = this.items
            }
            // var latestyear = new Date().getFullYear()
            // if (this.activeyear === '' && this.browserName !== 'safari') {
            //   this.filteryear(latestyear)
            // }
            this.disableStatusSelection = false
            this.loading = false
          },
          response => {
            if (response.body.message === 'Unauthorized. User has been logged out.') {
              this.refreshtoken()
              setTimeout(() => {
                this.Reload()
              }, 1000)
            }
          }
        )
    },
    refreshtoken () {
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      }
      var data = {}
      this.$http.post(this.$bitrixapi + 'partner/refreshToken', data, { headers }, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.success) {
              localStorage.setItem('id_token_portalbitrix', res.data.NEW_TOKEN)
              this.salesPersonbitrix = res.data.NEW_TOKEN
            } else {
              console.log('something is wrong with refreshing the token')
              this.$router.push('/login')
            }
          },
          response => {
            console.log('something is wrong with refreshing the token')
            this.$router.push('/login')
          }
        )
    },
    closereviewsmodal () {
      this.$refs.customerreviewsbypartners.hide()
    },
    getReviewIdbycustomerId (id) {
      this.$refs.customerreviewsbypartners.show()
      this.reviewsloading = true
      this.salesPersonbitrixbitrix = localStorage.getItem('id_token_portalbitrix')
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrixbitrix
      }
      var data = {}
      this.$http.get(this.$bitrixapi + 'partner/GetAllReviewsDoneByHomeOwners?customerId=' + id, { headers }, data, { emulateJSON: true }).then(
        response => {
          if (response.body.success) {
            this.customerdetails.name = response.body.data.NAME
            this.customerdetails.email = response.body.data.EMAIL
            this.customerdetails.address = response.body.data.ADDRESS
            this.customerdetails.mobile = response.body.data.MOBILE
            this.customerdetails.image = response.body.data.PICTURE
            this.customerdetails.email_verified = response.body.data.EMAIL_VERIFIED
            this.customerdetails.payproffv2_account_id = response.body.data.IS_PAYPROFF_VERIFIED
            this.allreviewsbycid = response.body.data.REVIEWS
            this.reviewsloading = false
          } else {
            this.reviewsloading = false
          }
        },
        response => {
          if (response.body.message === 'Unauthorized. User has been logged out.') {
            this.refreshtoken()
            setTimeout(() => {
              this.getReviewIdbycustomerId()
            }, 1000)
          }
        }
      )
    },
    onClick (item, i) {
      item.index = i
    },
    filterSearch (item) {
      return item
    },
    updateSearch () {
      var items = []
      items = this.items.filter((item) => {
        return item.firstname.toLowerCase().includes(this.search.toLowerCase()) || item.lastname.toLowerCase().includes(this.search.toLowerCase()) || item.mailingstreet.toLowerCase().includes(this.search.toLowerCase()) || item.mailingzip.toLowerCase().includes(this.search.toLowerCase()) || item.mailingcity.toLowerCase().includes(this.search.toLowerCase()) || item.email.toLowerCase().includes(this.search.toLowerCase()) || item.comment_to_partner.toLowerCase().includes(this.search.toLowerCase()) || item.comment_to_customer.toLowerCase().includes(this.search.toLowerCase()) || item.mobile.toLowerCase().includes(this.search.toLowerCase())
      })
      this.SearchItem = this.filterSearch(items)
    },
    toggleSort (statusDate) {
      var items = []
      var order
      if (statusDate === '1') {
        order = this.oldestFirst ? 1 : -1
        items = this.items.sort(function (a, b) {
          a = new Date(a.appointment_date + ' ' + a.id_times)
          b = new Date(b.appointment_date + ' ' + b.id_times)
          var results = a > b ? -1 : a < b ? 1 : 0
          return results * order
        })
        this.SearchItem = this.filterSearch(items)
        this.oldestFirst = !this.oldestFirst
      } else if (statusDate === '2') {
        order = this.ascending ? 1 : -1
        items = this.items.sort(function (a, b) {
          a = a.id_appointment_status
          b = b.id_appointment_status
          var results = a > b ? -1 : a < b ? 1 : 0
          return results * order
        })
        this.SearchItem = this.filterSearch(items)
        this.ascending = !this.ascending
      } else if (statusDate === '3') {
        order = this.oldestFirst ? 1 : -1
        items = this.items.sort(function (a, b) {
          a = new Date(a.tilbud_date)
          b = new Date(b.tilbud_date)
          var results = a > b ? -1 : a < b ? 1 : 0
          return results * order
        })
        this.SearchItem = this.filterSearch(items)
        this.oldestFirst = !this.oldestFirst
      } else if (statusDate === '4') {
        order = this.oldestFirst ? 1 : -1
        items = this.items.sort(function (a, b) {
          a = new Date(a.datereserve)
          b = new Date(b.datereserve)
          var results = a > b ? -1 : a < b ? 1 : 0
          return results * order
        })
        this.SearchItem = this.filterSearch(items)
        this.oldestFirst = !this.oldestFirst
      } else {

      }
    },
    toggleFilter (status) {
      var items = []
      var filtered = []
      if (status.length !== 0) {
        for (var i = 0; i < status.length; i++) {
          if (status[i] === '9') {
            items = this.items.filter((item) => {
              return item.privatecustomer.includes('1')
            })
            items.forEach(function (value) {
              filtered.push(value)
            })
          }
          if (status[i] === '10') {
            items = this.items.filter((item) => {
              return item.privatecustomer.includes('0')
            })
            items.forEach(function (value) {
              filtered.push(value)
            })
          }
          if (status[i] < 7 || status[i] === '100') {
            var statuscatcher = parseInt(status[i])
            items = this.items.filter((item) => {
              return item.tilbudstatus === statuscatcher
            })
            items.forEach(function (value) {
              filtered.push(value)
            })
          }
          if (status[i] === '8') {
            items = this.items.filter((item) => {
              return item.id_appointment.length > 1
            })
            items.forEach(function (value) {
              filtered.push(value)
            })
          }
          if (status[i] === '7') {
            items = this.items.filter((item) => {
              return item.id_appointment.length < 1
            })
            items.forEach(function (value) {
              filtered.push(value)
            })
          }
          if (status[i] === '12') {
            items = this.items.filter((item) => {
              return item.tilbudstatus === 6
            })
            items.forEach(function (value) {
              filtered.push(value)
            })
          }
        }
        this.SearchItem = this.filterSearch(filtered)
      } else {
        this.SearchItem = this.filterSearch(this.items)
      }
    },
    UpdateTilbud (files) {
      this.files = files
    },
    prisUrlOpen (item) {
      this.modalShowPris = true
      this.urlpris = item.potentialnameurl
    },
    prisUrlOpendato (item) {
      this.modalShowPris = true
      this.urlpris = item.changedateurl
    },
    prisUrlOpenFile (item) {
      this.modalShowPris = true
      this.urlpris = item.potentialnameurl + '&file=1'
    },
    changeStatus (value, item) {
      this.statusValue = value
      this.statusItem = item
      this.disableStatusSelection = true
      // Price feedback
      if (value === '2' || value === '3' || value === '4') {
        if (item.pricefeedback === '0') {
          this.feedbackLoading = true
          this.showPriceFeedBackModal()
        } else {
          this.updateStatus(value, item)
        }
      // Survey feedback
      } else if (value === '5' || value === '6') {
        this.feedbackLoading = true
        this.showSurveyModal()
      } else if (value === '100') {
        this.showikkeform()
      } else {
        this.updateStatus(value, item)
      }
    },
    updateStatusOther () {
      // https://docs.google.com/document/d/19wkBrLhE3YJKMIVEqtdCXHzOfc1pL2-b_UphTNKqqDo/edit
      var item = this.statusItem
      var valueid = this.optionikke
      var dataPartner = {
        operation: 'customer_other_status_henttilbud',
        salesPersonbitrix: this.salesPersonbitrix,
        status: valueid,
        cid: item.id_appointment
      }
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            this.updateStatus(100, item)
            this.closeSurveyModalikke()
            let obj = {
              title: 'Gennemført!',
              message: '',
              type: 'success',
              customCloseBtnText: 'Luk'
            }
            this.$refs.simplert.openSimplert(obj)
          },
          response => {
            console.log('Error in updateStatus()', response)
          }
        )
    },
    updateStatus (value, item) {
      this.modalPriceFeedback = false
      this.modalSurvey = false
      this.isLoadingReview = true
      var dataPartner = {operation: 'customer_status_henttilbud', salesPersonbitrix: this.salesPersonbitrix, status: value, cid: item.id_appointment, descp: this.surveyDescription}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.isLoadingReview = false
            this.surveyDescription = ''
            var infoType = ''
            if (res.success) {
              infoType = 'success'
            } else {
              infoType = 'info'
            }
            let obj = {
              title: res.message,
              message: '',
              type: infoType,
              customCloseBtnText: 'Luk'
            }
            this.$refs.simplert.openSimplert(obj)
            this.Reload()
          },
          response => {
            console.log('Error in updateStatus()', response)
          }
        )
    },
    submitSurveyDescription () {
      if (this.surveyDescription !== '') {
        var value = this.statusValue
        var item = this.statusItem
        if (value === '100') {
          this.modalSurvey = false
          var thisVar = this
          setTimeout(function () {
            thisVar.statusConfirmation = true
          }, 1000)
        } else {
          this.updateStatus(value, item)
        }
      } else {
        this.$toastr('error', 'Felter påkrævet')
      }
    },
    feedbackLoaded () {
    },
    priceManualChanged () {
      if (this.priceFeedBackData.priceManualChecked) {
        this.priceFeedBackData.priceManualDisabled = false
      } else {
        this.priceFeedBackData.priceManualDisabled = true
      }
    },
    getSurveyId () {
      var data = {operation: 'partner_survey', salesPersonbitrix: this.salesPersonbitrix}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.surveyId = res.url
          },
          response => {
            console.log('Error in getSurveyId()', response)
          }
        )
    },
    showPriceFeedBackModal () {
      this.modalPriceFeedback = true
      var thisVar = this
      setTimeout(function () {
        thisVar.feedbackLoading = false
      }, 1000)
    },
    closePriceFeedBackModal () {
      var value = this.statusValue
      var item = this.statusItem
      if (value === '4') {
        setTimeout(function () {
          var buttonRecommendation = document.getElementById('recommendInvitation-' + item.id_appointment)
          buttonRecommendation.click()
        }, 1000)
      } else {
        this.updateStatus(value, item)
      }
      this.modalPriceFeedback = false
      this.priceFeedBackData.priceManualChecked = false
      this.priceFeedBackData.price = 0
      this.priceFeedBackData.priceManualDisabled = true
      this.priceFeedBackData.steps = 1
      this.priceFeedBackData.nps = 0
      this.priceFeedBackData.note = ''
    },
    showSurveyModal () {
      this.modalSurvey = true
      var thisVar = this
      setTimeout(function () {
        thisVar.feedbackLoading = false
        document.querySelector('#surveyPopup').classList.remove('hide')
      }, 1000)
    },
    closeSurveyModal () {
      // var value = this.statusValue
      // if (value === '100') {
      //   // var thisVar = this
      //   // setTimeout(function () {
      //   //   thisVar.statusConfirmation = true
      //   // }, 1000)
      // } else if (value === '5') {
      //   // this.cancelDidNotWinTask()
      //   // setTimeout(function () {
      //   //   var buttonDidNotWinTask = document.getElementById('didNotWinTask-' + item.id_appointment)
      //   //   buttonDidNotWinTask.click()
      //   // }, 1000)
      // } else {
      //   this.Reload()
      // }
      this.surveyDescription = ''
      this.Reload()
      this.modalSurvey = false
    },
    getPartnerImage () {
      var data = {operation: 'oversigt_partner_haa', salesPersonbitrix: this.salesPersonbitrix, levid: this.haaId}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.resultImages.length !== 0) {
              this.partnerImg = res.resultImages[0].FileLocation
            }
          },
          response => {
            alert('error')
          }
        )
    },
    confirmRecommendInvitation (value, item, answer) {
      if (answer === 'yes') {
        return dialog => this.sendRecommendInvitation(value, item)
      } else {
        return dialog => this.dontSendRecommendInvitation(value, item)
      }
    },
    confirmRecommendInvitationnew () {
      var value = this.statusValue
      var item = this.statusItem
      this.statusConfirmation = false
      this.updateStatus(value, item)
    },
    cancelRecommendInvitationnew () {
      this.Reload()
      this.surveyDescription = ''
      this.statusConfirmation = false
    },
    showMeetingTilbudcreate (item) {
      this.$router.push('/tilbud/standardTilbud?app=' + item.CUSTOMER_ID + '&projectId=' + item.PROJECT_ID + '&contactId=' + item.CUSTOMER_ID + '&name=' + item.CUSTOMER_NAME + '&email=' + item.CUSTOMER_EMAIL + '&mobile=' + item.CUSTOMER_MOBILE + '&address=' + item.PROJECT_ADDRESS)
    },
    sendRecommendInvitation (value, item) {
      var customers = []
      customers.push({
        name: item.firstname + ' ' + item.lastname,
        email: item.email,
        mobile: item.mobile
      })
      var data = {
        operation: 'service_invite_action',
        salesPersonbitrix: this.salesPersonbitrix,
        levid: this.haaId,
        customers: JSON.stringify(customers),
        imgPicked: this.partnerImg,
        bcc: '0'
      }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.success) {
              this.updateStatus(value, item)
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    dontSendRecommendInvitation (value, item) {
      this.updateStatus(value, item)
    },
    cancelDidNotWinTask () {
      this.Reload()
      this.modalSurvey = false
    },
    showMeetingDetailsAflyse (item) {
      this.Aflysetitle = 'Er mødet med ' + item.firstname + ' ' + item.lastname + ' aflyst af kunden?'
      this.modalShowAflyse = true
      this.Aflyseid = item
      this.textAflyseReason = ''
      this.isLoadingAflyse = false
    },
    filterItem (items) {
      var newItem = []
      for (var iteme in items) {
        newItem.push(items[iteme])
      }
      return newItem
    },
    showMeetingDetails (item) {
      this.meetingShow = !this.meetingShow
      this.sampleMeeting.id = item.id
      this.sampleMeeting.type = item.type
      this.sampleMeeting.estimate = item.estimate
      this.sampleMeeting.city = item.city
      this.sampleMeeting.postnummer = item.postnummer
      this.sampleMeeting.price = item.price
      this.sampleMeeting.date = item.date
    },
    hideModal () {
      this.$refs.meetingModal.hide()
    }
  }
}
</script>
<style>
#Reviews .modal-dialog {
  max-width: 950px;
}
#Reviews .font12 {
  font-size: 12px;;
}
#Reviews .font10 {
  font-size: 10px;;
}
#Reviews .font14 {
  font-size: 14px;;
}
#Reviews .font13 {
  font-size: 13px;;
}
#Reviews .graylightcolor {
  color: #00364580;
}
@media (max-width:40em) {
  #Reviews .mobile-flex-column {
    flex-direction: column!important;
    align-items: center;
  }
  #Reviews .mmb3 {
    margin-bottom: 2rem;
  }
}
#mycustomerbolig .kundebutton {
  height: 50px;
}
.dg-content{
  white-space:pre-wrap;
}
.custom-control-input {
      position: unset;
    z-index: 1;
    opacity: 1;
    margin-right: 14px;
}
.image {
    width: 200px;
    height: 200px;
    background-size: contain;
    cursor: pointer;
    margin: 10px;
    border-radius: 3px;
}
.field-input {
  border-radius: 0!important;
  background: rgba(230, 234, 235, 0.5)!important;
  border:0!important;
}


.prisverslag .modal-content {
  min-height: 80vh;
}
.searchContainer {
  position: relative;
  overflow: hidden;
}
.searchIcon {
  padding: 0.5rem;
}
.searchBox {
  border: 0;
  flex: 1;
  outline:none;
}
::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: rgba(47, 54, 64, 0.5);
}
::-moz-placeholder { /* Firefox 19+ */
  color: rgba(47, 54, 64, 0.5);
}
:-ms-input-placeholder { /* IE 10+ */
  color: rgba(47, 54, 64, 0.5);
}
:-moz-placeholder { /* Firefox 18- */
  color: rgba(47, 54, 64, 0.5);
}
.switch.switch-text .switch-label {
  border: 0;
  background-color: lighten(grey, 17%);
}
.switch.switch-text .switch-handle {
  border:0;
}
.modal-footer {
  border-top: 0;
}
.modal-header {
  border-bottom:0;
  padding-bottom:0;
}
.henttilbud {
  border: 1px dashed #3FC380!important;
  padding: 4px;
}
.card-header {
  border-top: 0;
  border-bottom: 0;
  font-weight: 700;
}
.modal-dialog ul > li > span {
  word-break: break-word;
}
#dineNotater .vgs__container {
  background-color: #fff;
}
#dineNotater .vgs__close {
  color: #000;
  font-size: 2.5rem;
}
#priceFeedBack .el-checkbox__inner {
  width: 20px;
  height: 20px;
  border-color: #000;
}
#priceFeedBack .el-checkbox__inner::after {
  width: 4px;
  height: 10px;
  left: 7px;
}
#priceFeedBack span.el-checkbox__label {
  font-size: 1.25rem;
  font-weight: 600;
  color: #19a3c0;
}
#priceFeedBack .el-input-number {
  border: 1px solid;
  border-color: #19a3c0;
  border-radius: 6px;
  width: 100%;
}
#priceFeedBack .el-input-number input {
  font-size: 1.3rem;
  font-weight: 600;
  padding: 2.5rem 2rem;
  color: #19a3c0;
}
#priceFeedBack .el-slider__bar {
  height: 12px;
  border-radius: 5px;
}
#priceFeedBack .el-slider__runway {
  height: 12px;
  border-radius: 5px;
}
#priceFeedBack .el-slider__button {
  width: 20px;
  height: 20px;
  background-color: #409EFF;
}
#priceFeedBack .el-slider__button-wrapper {
  top: -12px;
}
#priceFeedBack .el-radio-button__inner {
  font-size: 1.4rem;
  color: #19a3c0;
  border-color: #19a3c0;
  padding: 12px 20px;
  border: 1px solid #19a3c0;
  border-left: 0;
}
#priceFeedBack .el-radio-button:first-child .el-radio-button__inner {
  border-left: 1px solid #19a3c0;
}
#priceFeedBack .el-radio-button__orig-radio:checked+.el-radio-button__inner {
  color: #fff;
}
#priceFeedBack .el-textarea textarea {
  border-color: #19a3c0;
}
#priceFeedBack .custom-saved {
  color: #3c763d;
  font-weight: 600;
  background-color: #dff0d8;
  border-color: #d6e9c6;
  padding: 3rem 2rem;
}
@media screen and (max-width: 640px) {
  .card {
    min-width: 100%;
    margin-bottom: 24px;
  }
  #priceFeedBack .el-radio-button {
    border-left: 1px solid #19a3c0;
    border-radius: 2px;
  }
}
.loader,
.loader:before,
.loader:after {
  border-radius: 50%;
}
.loader {
  color: #143130;
  font-size: 11px;
  text-indent: -99999em;
  margin: 55px auto;
  position: relative;
  width: 10em;
  height: 10em;
  box-shadow: inset 0 0 0 1em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.loader:before,
.loader:after {
  position: absolute;
  content: '';
}
.loader:before {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 10.2em 0 0 10.2em;
  top: -0.1em;
  left: -0.1em;
  -webkit-transform-origin: 5.2em 5.1em;
  transform-origin: 5.2em 5.1em;
  -webkit-animation: load2 2s infinite ease 1.5s;
  animation: load2 2s infinite ease 1.5s;
}
.loader:after {
  width: 5.2em;
  height: 10.2em;
  background: white;
  border-radius: 0 10.2em 10.2em 0;
  top: -0.1em;
  left: 5.1em;
  -webkit-transform-origin: 0px 5.1em;
  transform-origin: 0px 5.1em;
  -webkit-animation: load2 2s infinite ease;
  animation: load2 2s infinite ease;
}
@-webkit-keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// AllMeetingsTable_minbolig.vue?07ee92e9